/**
 * Snapshot serialization for locking round/match results on completion.
 * Converts computed results into JSON-safe objects for JSONB storage.
 */

/**
 * Build a JSONB snapshot of round results for locking on completion.
 */
export function buildRoundSnapshot({ roundResults, moneyResults, handicapBreakdown, teamStructure, sideBets, pressData }) {
  return {
    version: 1,
    roundResults,
    moneyResults,
    teamStructure,
    handicapBreakdown: serializeHandicapBreakdown(handicapBreakdown),
    sideBets: sideBets || {},
    pressData: pressData || [],
  }
}

/**
 * Build a JSONB snapshot of match-level results.
 */
export function buildMatchSnapshot({ matchLowNet, matchLowGross, matchStableford, matchSkins }) {
  return {
    version: 3,
    matchLowNet: matchLowNet || null,
    matchLowGross: matchLowGross || null,
    matchStableford: matchStableford || null,
    matchSkins: matchSkins || null,
  }
}

/**
 * Convert handicap breakdown strokeHoles Maps to plain objects for JSON storage.
 */
function serializeHandicapBreakdown(breakdown) {
  if (!breakdown) return null
  return breakdown.map(entry => ({
    ...entry,
    strokeHoles: entry.strokeHoles instanceof Map
      ? Object.fromEntries(entry.strokeHoles)
      : entry.strokeHoles || {},
  }))
}

/**
 * Convert stored plain objects back to Maps for strokeHoles.
 */
export function deserializeHandicapBreakdown(breakdown) {
  if (!breakdown) return null
  return breakdown.map(entry => ({
    ...entry,
    strokeHoles: new Map(
      Object.entries(entry.strokeHoles || {}).map(([k, v]) => [Number(k), v])
    ),
  }))
}
